import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
  Backdrop,
  CircularProgress
} from '@mui/material';
import { AuthContext } from '../../../contexts/auth';

import UnimedLabel from '../../../components/labels/unimed';
import '../../../assets/fonts/fonts.css';

const HOST = process.env.REACT_APP_HOST;

export default function resetSenhaPage() {
  const [documento, setDocumento] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const handleDocumentoChange = (event) => {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length <= 11) {
      // Formata como CPF
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else {
      // Formata como CNPJ
      value = value.replace(/^(\d{2})(\d)/, '$1.$2');
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
      value = value.replace(/(\d{4})(\d)/, '$1-$2');
    }
    setDocumento(value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!documento || !email) {
      alert('Por favor, preencha todos os campos.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${HOST}/api/authenticate/resetUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          documento: documento,
          email
        }),
      });

      const data = await response.json();
      setLoading(false);

      if (data.exec === 'OK') {
        alert('Um link de recuperação de senha foi enviado para o seu e-mail.');
        navigate('/login');
      } else {
        alert(data.message || 'Não foi possível processar sua solicitação.');
      }
    } catch (error) {
      setLoading(false);
      console.error('Erro ao enviar solicitação de recuperação de senha:', error);
      alert('Ocorreu um erro. Tente novamente mais tarde.');
    }

  };

  const theme = createTheme({
    typography: {
      fontFamily: 'MyCustomFont, Arial',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '85vh',
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: 400,
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
              borderRadius: 8,
              p: 3,
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <Typography variant="h5" sx={{ color: 'rgba(0, 139, 80, 0.65)', mb: 2 }}>
              Recuperar Senha
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate>
              <TextField
                margin="normal"
                required
                fullWidth
                id="documento"
                label="CPF ou CNPJ"
                name="documento"
                autoComplete="off"
                autoFocus
                value={documento}
                onChange={handleDocumentoChange}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="E-mail"
                name="email"
                type="email"
                value={email}
                onChange={handleEmailChange}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, bgcolor: '#008b50', color: '#fafafa' }}
              >
                Enviar
              </Button>

              <Button
                fullWidth
                variant="text"
                onClick={() => navigate('/login')}
              >
                Voltar para Login
              </Button>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '10%',
            bgcolor: '#008b50',
            color: '#fafafa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            zIndex: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <UnimedLabel h={'24px'} w={'24px'} ml={'5px'} />
          </Box>
          <Typography variant="h6" sx={{ mr: 2, textAlign: 'end' }}>
            Região da <br />Campanha/RS
          </Typography>
        </Box>

        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    </ThemeProvider>
  );
}
